import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";

const getDefaultSelectedParkourBasedDynamicPricing = () => {
  return {
    search: {
      group_id: null,
      train_type: null,
      start_date: null,
      end_date: null,
      scheduleIds: [],
      lineStationsArray: [],
    },
    list: [],
  };
};

const getDefaultSelectedParkourBasedPricings = () => {
  return {
    scheduleIds: [],
    name: null,
    startDate: null,
    endDate: null,
    parkourBasedPricingFragments: [],
  };
};

export default {
  state: () => ({
    selectedParkourBasedPricings: getDefaultSelectedParkourBasedPricings(),
    selectedParkourBasedDynamicPricing: getDefaultSelectedParkourBasedDynamicPricing(),
  }),

  mutations: {
    setSelectedParkourBasedPricings(state, parkourBasedPricings) {
      Vue.set(state, "selectedParkourBasedPricings", parkourBasedPricings);
    },
    setSelectedParkourBasedDynamicPricing(state, parkourBasedDynamicPricing) {
      Vue.set(state, "selectedParkourBasedDynamicPricing", parkourBasedDynamicPricing);
    },
    setDefaultSelectedParkourBasedDynamicPricing(state) {
      Vue.set(state, "selectedParkourBasedDynamicPricing", getDefaultSelectedParkourBasedDynamicPricing());
    },
    setDefaultSelectedParkourBasedPricings(state) {
      Vue.set(state, "selectedParkourBasedPricings", getDefaultSelectedParkourBasedPricings());
    },
  },

  actions: {
    //TODO: load, update, create
    createParkourBasedPricings: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/parkour-based-pricings/entity", request, {})
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    loadParkourBasedPricings: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/parkour-based-pricings/entity").then((response) => {
        return objectUtils.convertPublishModelToUpdateModel(response.data);
      });
    },

    loadParkourBasedPricing: (context, id) => {
      return axios.get(context.getters.getMcServiceUrl + "/parkour-based-pricings/entity/" + id).then((response) => {
        // return objectUtils.convertPublishModelToUpdateModel(response.data);
        return response.data;
      });
    },

    loadPublishedParkourBasedPricings: (context) => {
      return axios.get(context.getters.getMcServiceUrl + "/parkour-based-pricings/entity/published").then((response) => {
        return response.data;
      });
    },

    updateParkourBasedPricings: (context, request) => {
      return axios.put(context.getters.getMcServiceUrl + "/parkour-based-pricings/entity", request, {}).then((response) => {
        return response.data;
      });
    },
    deleteParkourBasedPricings: (context, parkourBasedPricings) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/parkour-based-pricings/entity/" + parkourBasedPricings.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          parkourBasedPricings.intents = intents;
          parkourBasedPricings.intentId = response.data.id;
          return parkourBasedPricings;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftParkourBasedPricings: (context, parkourBasedPricings) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/parkour-based-pricings/draft/" + parkourBasedPricings.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },

    publishParkourBasedPricings: (context, intentId) => {
      return axios.get(context.getters.getMcServiceUrl + "/parkour-based-pricings/publish/" + intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        return response.data;
      });
    },

    loadSelectedParkourBasedPricingsHistory: (context, parkourBasedPricings) => {
      return axios.get(context.getters.getMcServiceUrl + "/parkour-based-pricings/history/" + parkourBasedPricings.id, {}).then((response) => {
        return response.data;
      });
    },

    updatePricingDates: (context, parkourBasedPricingsArray) => {
      return axios.post(context.getters.getMcServiceUrl + "/parkour-based-pricings/update-pricing-dates", parkourBasedPricingsArray).then((response) => {
        return response.data;
      });
    },

    rejectParkourBasedPricings: (context, parkourBasedPricings) => {
      return axios.get(context.getters.getMcServiceUrl + "/parkour-based-pricings/reject/" + parkourBasedPricings.intentId).then((response) => {
        if (parkourBasedPricings.intents[0].type === "DELETE_PARKOUR_BASED_PRICINGS") {
          parkourBasedPricings.intents = null;
          parkourBasedPricings.intentId = 0;
        } else if (parkourBasedPricings.intents[0].type === "CREATE_PARKOUR_BASED_PRICINGS") {
          parkourBasedPricings.intents[0].status = "DRAFT";
        } else if (parkourBasedPricings.intents[0].type === "UPDATE_PARKOUR_BASED_PRICINGS") {
          parkourBasedPricings.intents[0].status = "DRAFT";
        }
        return response.data;
      });
    },

    recallParkourBasedPricings: (context, parkourBasedPricings) => {
      return axios.get(context.getters.getMcServiceUrl + "/parkour-based-pricings/recall/" + parkourBasedPricings.intentId).then((response) => {
        //TODO:Name should starting with letter.
        helper.recallOrRejectEntity(parkourBasedPricings, "PARKOUR_BASED_PRICING");
        return response.data;
      });
    },

    cancelParkourBasedPricings: (context, parkourBasedPricings) => {
      return axios.get(context.getters.getMcServiceUrl + "/parkour-based-pricings/cancel/" + parkourBasedPricings.intentId).then((response) => {
        //TODO:Name should starting with letter.
        return response.data;
      });
    },

    sendToApprovalParkourBasedPricings: (context, parkourBasedPricings) => {
      return axios.get(context.getters.getMcServiceUrl + "/parkour-based-pricings/sendToApproval/" + parkourBasedPricings.intentId).then((response) => {
        if (parkourBasedPricings.intents[0].type === "CREATE_PARKOUR_BASED_PRICING") {
          parkourBasedPricings.intents[0].status = "WAITING_APPROVAL";
        } else if (parkourBasedPricings.intents[0].type === "'CREATE_PARKOUR_BASED_PRICING") {
          parkourBasedPricings.intents[0].status = "WAITING_APPROVAL";
        }
        return response.data;
      });
    },
    createParkourBasedDynamicPricing: (context, request) => {
      return axios
        .post(context.getters.getDynamicPricing + "/parkour_base_single_pricing/", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
  },
  getters: {
    getSelectedParkourBasedPricings: (state) => {
      return state.selectedParkourBasedPricings;
    },
    getSelectedParkourBasedDynamicPricing: (state) => {
      return state.selectedParkourBasedDynamicPricing;
    },
  },
};
